interface RoleBadgeProps {
  role: string
  variant?: 'full' | 'compact' | 'dot'
}

const colorClasses = (role: string) =>
  role === 'DIRECTOR'
    ? 'bg-purple-50 text-purple-700'
    : role === 'COACH'
    ? 'bg-primary-50 text-primary-700'
    : 'bg-blue-50 text-blue-700'

export const RoleBadge = ({ role, variant = 'full' }: RoleBadgeProps) => {
  const colors = colorClasses(role)

  if (variant === 'dot') {
    return (
      <span className={`w-5 h-5 flex items-center justify-center text-[10px] font-bold ${colors}`}>
        {role.charAt(0)}
      </span>
    )
  }

  if (variant === 'compact') {
    return (
      <span className={`px-1.5 py-0.5 text-xs font-semibold ${colors}`}>
        {role.charAt(0)}
      </span>
    )
  }

  return (
    <span className={`px-2.5 py-1 text-xs font-semibold ${colors}`}>
      {role}
    </span>
  )
}
